// src/components/Header.js
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import ThemeContext from '../context/ThemeContext';
import headshot from '../assets/headshot.jpg'; 

// Style the header based on the theme context
const HeaderContainer = styled.header`
  background-color: ${({ theme }) => theme.mainField};
  color: ${({ theme }) => theme.mainText};
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 1000;
  height: 45px;
`;

const NavLinks = styled.div`
  position: relative;
  margin-right: 21px; /* Add space on the right before the edge of the screen */
  a {
    margin: 0 15px;
    text-decoration: none;
    color: ${({ theme }) => theme.mainText};
    position: relative;
  }

  a:hover {
    color: ${({ theme }) => theme.mainAccent};
  }

  a:hover::after {
    content: 'Beta';
    position: absolute;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${({ theme }) => theme.mainBody};
    color: ${({ theme }) => theme.mainAccent};
    padding: 5px;
    border-radius: 5px;
    white-space: nowrap;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    font-size: 0.9em;
  }
`;

// Define the Headshot styled component
const Headshot = styled.img`
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.4);
  width: auto;
  height: auto;
  border-radius: 50%;
  margin-right: 15px;
  object-fit: cover;
  max-width: 100px;
`;

const Header = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <HeaderContainer theme={theme}>
      <Headshot src={headshot} alt="Headshot" /> 
      <NavLinks theme={theme}>
        <Link to="/">Home</Link>
        <Link to="/customization">Customization</Link>
        <Link to="/contact">Contact</Link>
      </NavLinks>
    </HeaderContainer>
  );
};

export default Header;
